var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-area"},[_vm._t("default")],2),(_vm.$slots.icon)?_c('div',{staticClass:"input-group-icon"},[_vm._t("icon")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }